import {Api} from "./api"

export default class TeamApi extends Api {
    constructor() {
        super("/team");
    }

    async createTeam(teamName: string, teamWoaToken: string) {
        return await this.call("/create_team", {teamName, teamWoaToken})
    }

    async updateTeam(teamWoaToken: string) {
        return await this.call("/update_team", {teamWoaToken})
    }

    async listTeam() {
        return await this.call("/list_team").then()
    }

    async getTeam() {
        return await this.call("/get_team")
    }

    async numTeam() {
        return await this.call("/num_team")
    }

    async resetTeamKey() {
        return await this.call("/resetKey_team")
    }

    async joinTeam(teamKey: string) {
        return await this.call("/addIn_team", {teamKey})
    }

}